<template>
  <div>
    <div class="card">
      <div class="card-header" data-background-color="magenta">
        <div class="row">
          <div class="col-md-8">
            <h4 class="title">{{car.info.make}} {{car.info.model}} {{car.info.color}}</h4>
          </div>
          <div class="col-md-3">
            <h4 class="title">{{account.name}}</h4>
          </div>
          <div class="col-md-1">
            <i role="button" @click="showInstance" class="material-icons" v-if="!show">expand_more</i>
            <i role="button" @click="showInstance" class="material-icons" v-if="show">expand_less</i>
          </div>
        </div>
      </div>

      <div class="card-content">
        <div class="row">
          <div class="col-md-5 col-md-offset-1">
            <span>
              <b>Año:</b>
              {{car.info.year}}
            </span>
            <br>
            <span>
              <b>Patente:</b>
              {{car.info.domain}}
            </span>
          </div>
          <div class="col-md-5 col-md-offset-1">
            <span>
              <b>{{account.identification_type}}:</b>
              {{account.identification_number}}
            </span>
            <br>
            <span v-if="hasPhones">
              <b>Teléfono:</b>
              {{account.phones[0].number}}
            </span>
          </div>
        </div>
        <div class="row" v-if="show">
          <div class="col-md-6">
            <div class="card-content">
              <car-props @input-changed="input_changed" :car="myCopyCar"></car-props>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card-content">
              <magenta-address-form @input-changed="input_changed" :home="myCopyAccount"></magenta-address-form>
              <!-- <user-props :account="account"></user-props> -->
            </div>
          </div>
        </div>

        <div class="row" v-if="show && errorGps">
          <div class="col-md-offset-1">
            <h4>
              <span
                class="form-group__message help is-danger"
              >Se ha producido un error obteniendo el gps, por favor intente nuevamente.</span>
            </h4>
          </div>
        </div>

        <div class="row" v-if="show && !errorGps">
          <div class="col-md-offset-1 col-md-10">
            <div class="card-content">
              <h4>Información del GPS</h4>
              <g-p-s-form :editable="false" :gps="gps.info"></g-p-s-form>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-offset-10" v-if="show">
            <button
              type="submit"
              @click.prevent="save"
              class="btn btn-primary"
              :disabled="disabledGuardar"
            >Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <loader-modal
      v-if="showModal"
      :working="modalWorking"
      :error-ocurred="errorOcurred"
      :error="error"
      :close="closeSuccess"
      :close-failure="closeFailure"
    />
  </div>
</template>

<script>
import CarProps from "./CarProps.vue";
import UserProps from "./UserProps.vue";
import MagentaAddressForm from "./MagentaAddressForm.vue";
import LoaderModal from "../Utils/LoaderModal.vue";
import GPSForm from "src/components/Dashboard/Views/Products/GPSForm.vue";

import ThingsService from "src/thingsService.js";
import AccountService from "src/accountService.js";

export default {
  components: {
    CarProps,
    UserProps,
    GPSForm,
    MagentaAddressForm,
    LoaderModal
  },
  data() {
    return {
      show: false,
      disabledGuardar: false,
      formErrors: {
        año: false,
        "codigo postal": false
      },
      error: null,
      showModal: false,
      modalWorking: true,
      errorOcurred: false,
      myCopyCar: JSON.parse(JSON.stringify(this.car)),
      myCopyAccount: JSON.parse(JSON.stringify(this.account))
    };
  },
  computed: {
    hasPhones: function() {
      return (
        this.account.phones !== null &&
        this.account.phones !== undefined &&
        this.account.phones.length > 0
      );
    }
  },

  props: {
    car: {
      type: Object,
      default: function() {
        return {
          info: {
            make: "",
            model: "",
            domain: "",
            year: "",
            color: "",
            engine_number: "",
            chassis_number: ""
          }
        };
      }
    },
    gps: null,
    account: null,
    errorGps: null
  },
  methods: {
    save: async function() {
      this.showModal = true;
      let car_changed = this.carChanged();
      let account_changed = this.accountChanged();
      if (!car_changed && !account_changed) {
        this.setFailure("No se realizaron cambios");
      } else {
        if (car_changed) await this.changeCar();
        if (account_changed) await this.changeAccount();
      }
    },

    closeSuccess() {
      this.modalWorking = true;
      this.showModal = false;
    },

    closeFailure() {
      this.modalWorking = true;
      this.showModal = false;
    },

    setFailure(errorMessage) {
      this.error = errorMessage;
      this.modalWorking = false;
      this.errorOcurred = true;
    },

    setSuccess() {
      this.modalWorking = false;
      this.errorOcurred = false;
    },

    showInstance: function() {
      this.show = !this.show;
    },
    input_changed(key, has_error) {
      this.formErrors[key] = has_error;
      this.validate();
    },
    validate() {
      var values = Object.values(this.formErrors);
      const reducer = (acumm, current) => acumm || current;
      this.disabledGuardar = values.reduce(reducer, false);
    },

    carChanged() {
      return (
        this.car.info.make !== this.myCopyCar.info.make ||
        this.car.info.model !== this.myCopyCar.info.model ||
        this.car.info.color !== this.myCopyCar.info.color
      );
    },
    async changeCar() {
      var changeSet = [];
      this.car.info.make !== this.myCopyCar.info.make
        ? changeSet.push({
            action: "update",
            path: "/make",
            value: this.myCopyCar.info.make
          })
        : null;
      this.car.info.model !== this.myCopyCar.info.model
        ? changeSet.push({
            action: "update",
            path: "/model",
            value: this.myCopyCar.info.model
          })
        : null;
      this.car.info.color !== this.myCopyCar.info.color
        ? changeSet.push({
            action: "update",
            path: "/color",
            value: this.myCopyCar.info.color
          })
        : null;
      if (changeSet.length > 0) {
        try {
          let response = await ThingsService.patch(this.car.id, changeSet);
          this.$emit("car-change", response.body);
          this.setSuccess();
        } catch (error) {
          let faiureText =
            "Error actualizando el vehículo. Reintente o contacte a un adminsitrador.";
          if (error.body) faiureText = error.body.description;
          this.setFailure(faiureText);
        }
      }
    },

    accountChanged() {
      return (
        this.account.address.address_line1 !==
          this.myCopyAccount.address.address_line1 ||
        this.account.address.address_line2 !==
          this.myCopyAccount.address.address_line2 ||
        this.account.address.city !== this.myCopyAccount.address.city ||
        this.account.address.country !== this.myCopyAccount.address.country ||
        this.account.address.postal_code !==
          this.myCopyAccount.address.postal_code ||
        this.account.address.state !== this.myCopyAccount.address.state
      );
    },

    async changeAccount() {
      var changeSet = [];
      this.account.address.address_line1 !==
      this.myCopyAccount.address.address_line1
        ? changeSet.push({
            action: "update",
            path: "/address/address_line1",
            value: this.myCopyAccount.address.address_line1
          })
        : null;
      this.account.address.address_line2 !==
      this.myCopyAccount.address.address_line2
        ? changeSet.push({
            action: "update",
            path: "/address/address_line2",
            value: this.myCopyAccount.address.address_line2
          })
        : null;
      this.account.address.city !== this.myCopyAccount.address.city
        ? changeSet.push({
            action: "update",
            path: "/address/city",
            value: this.myCopyAccount.address.city
          })
        : null;
      this.account.address.country !== this.myCopyAccount.address.country
        ? changeSet.push({
            action: "update",
            path: "/address/country",
            value: this.myCopyAccount.address.country
          })
        : null;
      this.account.address.postal_code !==
      this.myCopyAccount.address.postal_code
        ? changeSet.push({
            action: "update",
            path: "/address/postal_code",
            value: this.myCopyAccount.address.postal_code
          })
        : null;
      this.account.address.state !== this.myCopyAccount.address.state
        ? changeSet.push({
            action: "update",
            path: "/address/state",
            value: this.myCopyAccount.address.state
          })
        : null;
      if (changeSet.length > 0) {
        try {
          let response = await AccountService.patch(this.account.id, changeSet);
          this.$emit("account-change", response.body);
          this.setSuccess();
        } catch (error) {
          let faiureText =
            "Error actualizando la cuenta. Reintente o contacte a un administrador.";
          if (error.body) faiureText = error.body.description;
          this.setFailure(faiureText);
        }
      }
    }
  }
};
</script>

<style>
button {
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// ChangeCar.vue?5946ea02